/*
    storage 主要放项目中的storage相关操作：存取等
*/
var localStorage = {
  /**
   对本地数据进行操作的相关方法，如localStorage,sessionStorage的封装
  */
  setStorage: function (key, value, duration) {
    window.localStorage[key] = JSON.stringify(value)
  },
  getStorage: function (key) {
    var data = window.localStorage[key]
    if (!data || data === 'null') {
      return null
    }
    // var now = this.getCurrentTimeStamp()
    var obj
    try {
      obj = JSON.parse(data)
    } catch (e) {
      return null
    }
    return obj
  },
  removeStorage: function (key) {
    window.localStorage.removeItem(key)
  },
  getCurrentTimeStamp: function () {
    return Date.parse(new Date())
  }
}
export default localStorage



//////////////////
// WEBPACK FOOTER
// ./http/localStorage.js
// module id = null
// module chunks = 